import { useState, useEffect } from 'react';
import withAuth from '../../auth/WithAuth';
import './transactions.scss';
import FurnitureNavbar from '../../../components/layout/Nav';

const TransactionsManagement = () => {
  const [transactions, setTransactions] = useState([]);
  const [loading, setLoading] = useState(true);
  const [filters, setFilters] = useState({
    type: 'all',
    status: 'all',
    dateRange: 'all',
    search: '',
  });

  // Enhanced dummy transactions data
  const dummyTransactions = [
    {
      id: 'TX-001',
      type: 'payment',
      status: 'completed',
      amount: 45000,
      user_name: 'Alice Smith',
      user_email: 'alice@example.com',
      user_type: 'client',
      project_title: 'Custom Wooden Dining Table',
      created_at: '2025-01-20T10:30:00Z',
      completed_at: '2025-01-20T10:35:00Z',
      payment_method: 'M-Pesa',
      reference: 'MPE234567890',
      fee: 1350,
      net_amount: 43650,
      description: 'Project payment for dining table',
    },
    {
      id: 'TX-002',
      type: 'commission',
      status: 'completed',
      amount: 2250,
      user_name: 'John Kamau',
      user_email: 'john@example.com',
      user_type: 'artisan',
      project_title: 'Custom Wooden Dining Table',
      created_at: '2025-01-20T11:00:00Z',
      completed_at: '2025-01-20T11:00:00Z',
      payment_method: 'System',
      reference: 'COM001',
      fee: 0,
      net_amount: 2250,
      description: 'Platform commission (5%)',
    },
    {
      id: 'TX-003',
      type: 'payout',
      status: 'pending',
      amount: 42750,
      user_name: 'John Kamau',
      user_email: 'john@example.com',
      user_type: 'artisan',
      project_title: 'Custom Wooden Dining Table',
      created_at: '2025-01-20T11:15:00Z',
      completed_at: null,
      payment_method: 'Bank Transfer',
      reference: 'PYT001',
      fee: 0,
      net_amount: 42750,
      description: 'Artisan payout for completed project',
    },
    {
      id: 'TX-004',
      type: 'payment',
      status: 'failed',
      amount: 25000,
      user_name: 'Bob Johnson',
      user_email: 'bob@example.com',
      user_type: 'client',
      project_title: 'Office Desk Setup',
      created_at: '2025-01-19T14:20:00Z',
      completed_at: null,
      payment_method: 'Card',
      reference: 'CRD987654321',
      fee: 750,
      net_amount: 24250,
      description: 'Project payment - Insufficient funds',
      failure_reason: 'Insufficient funds',
    },
    {
      id: 'TX-005',
      type: 'refund',
      status: 'completed',
      amount: 18000,
      user_name: 'Dana White',
      user_email: 'dana@example.com',
      user_type: 'client',
      project_title: 'Outdoor Garden Bench',
      created_at: '2025-01-18T09:45:00Z',
      completed_at: '2025-01-18T10:15:00Z',
      payment_method: 'M-Pesa',
      reference: 'RFN001',
      fee: 0,
      net_amount: 18000,
      description: 'Project cancellation refund',
    },
    {
      id: 'TX-006',
      type: 'payment',
      status: 'completed',
      amount: 75000,
      user_name: 'Fiona Gallagher',
      user_email: 'fiona@example.com',
      user_type: 'client',
      project_title: 'Kitchen Cabinet Refacing',
      created_at: '2025-01-17T16:30:00Z',
      completed_at: '2025-01-17T16:32:00Z',
      payment_method: 'Card',
      reference: 'CRD123456789',
      fee: 2250,
      net_amount: 72750,
      description: 'Project payment for kitchen cabinets',
    },
    {
      id: 'TX-007',
      type: 'commission',
      status: 'completed',
      amount: 3750,
      user_name: 'Platform',
      user_email: 'admin@craftconnect.com',
      user_type: 'system',
      project_title: 'Kitchen Cabinet Refacing',
      created_at: '2025-01-17T16:35:00Z',
      completed_at: '2025-01-17T16:35:00Z',
      payment_method: 'System',
      reference: 'COM002',
      fee: 0,
      net_amount: 3750,
      description: 'Platform commission (5%)',
    },
    {
      id: 'TX-008',
      type: 'payment',
      status: 'pending',
      amount: 32000,
      user_name: 'George Martin',
      user_email: 'george@example.com',
      user_type: 'client',
      project_title: 'Custom Bed Frame',
      created_at: '2025-01-16T13:20:00Z',
      completed_at: null,
      payment_method: 'M-Pesa',
      reference: 'MPE345678901',
      fee: 960,
      net_amount: 31040,
      description: 'Project payment - Pending confirmation',
    },
    {
      id: 'TX-009',
      type: 'payout',
      status: 'completed',
      amount: 28000,
      user_name: 'David Kimani',
      user_email: 'david@example.com',
      user_type: 'artisan',
      project_title: 'Steel Staircase Railing',
      created_at: '2025-01-15T11:00:00Z',
      completed_at: '2025-01-15T11:30:00Z',
      payment_method: 'Bank Transfer',
      reference: 'PYT002',
      fee: 0,
      net_amount: 28000,
      description: 'Artisan payout for completed project',
    },
    {
      id: 'TX-010',
      type: 'refund',
      status: 'cancelled',
      amount: 12000,
      user_name: 'Ethan Hunt',
      user_email: 'ethan@example.com',
      user_type: 'client',
      project_title: 'Outdoor Garden Bench',
      created_at: '2025-01-14T15:45:00Z',
      completed_at: null,
      payment_method: 'M-Pesa',
      reference: 'RFN002',
      fee: 0,
      net_amount: 12000,
      description: 'Refund cancelled - Dispute resolved',
      failure_reason: 'Dispute resolved in favor of artisan',
    },
  ];

  useEffect(() => {
    // Simulate API fetch with loading state
    setTimeout(() => {
      setTransactions(dummyTransactions);
      setLoading(false);
    }, 1000);
  }, []);

  const filteredTransactions = transactions.filter((transaction) => {
    if (filters.type !== 'all' && transaction.type !== filters.type)
      return false;
    if (filters.status !== 'all' && transaction.status !== filters.status)
      return false;
    if (
      filters.search &&
      !transaction.id.toLowerCase().includes(filters.search.toLowerCase()) &&
      !transaction.user_name
        .toLowerCase()
        .includes(filters.search.toLowerCase()) &&
      !transaction.project_title
        .toLowerCase()
        .includes(filters.search.toLowerCase())
    )
      return false;

    // Date range filtering
    if (filters.dateRange !== 'all') {
      const transactionDate = new Date(transaction.created_at);
      const now = new Date();
      let startDate = new Date();

      switch (filters.dateRange) {
        case 'today':
          startDate.setHours(0, 0, 0, 0);
          break;
        case 'week':
          startDate.setDate(now.getDate() - 7);
          break;
        case 'month':
          startDate.setMonth(now.getMonth() - 1);
          break;
        default:
          return true;
      }

      if (transactionDate < startDate) return false;
    }

    return true;
  });

  const getTotalRevenue = () => {
    return transactions
      .filter((t) => t.status === 'completed' && t.type === 'payment')
      .reduce((sum, t) => sum + (t.amount || 0), 0);
  };

  const getCommissionEarned = () => {
    return transactions
      .filter((t) => t.status === 'completed' && t.type === 'commission')
      .reduce((sum, t) => sum + (t.amount || 0), 0);
  };

  const getPendingPayouts = () => {
    return transactions
      .filter((t) => t.status === 'pending' && t.type === 'payout')
      .reduce((sum, t) => sum + (t.amount || 0), 0);
  };

  const getFailedCount = () => {
    return transactions.filter((t) => t.status === 'failed').length;
  };

  const handleStatusUpdate = (transactionId, newStatus) => {
    const updated = transactions.map((t) =>
      t.id === transactionId ? { ...t, status: newStatus } : t
    );
    setTransactions(updated);
  };

  const handleBulkAction = (action) => {
    alert(`Bulk action: ${action} selected`);
  };

  const getStatusInfo = (status) => {
    const info = {
      completed: { color: '#10b981', icon: '✅', label: 'Completed' },
      pending: { color: '#f59e0b', icon: '⏳', label: 'Pending' },
      failed: { color: '#ef4444', icon: '❌', label: 'Failed' },
      cancelled: { color: '#6b7280', icon: '🚫', label: 'Cancelled' },
    };
    return info[status] || { color: '#6b7280', icon: '❓', label: 'Unknown' };
  };

  const getTypeInfo = (type) => {
    const info = {
      payment: { color: '#3b82f6', icon: '💰', label: 'Payment' },
      payout: { color: '#8b5cf6', icon: '💸', label: 'Payout' },
      commission: { color: '#f59e0b', icon: '📊', label: 'Commission' },
      refund: { color: '#ef4444', icon: '↩️', label: 'Refund' },
    };
    return info[type] || { color: '#6b7280', icon: '❓', label: 'Unknown' };
  };

  return (
    <>
      <FurnitureNavbar />
      <div className="admin-transactions">
        <div className="page-header">
          <div className="header-content">
            <div className="header-text">
              <h1>💰 Financial Transactions</h1>
              <p>Manage payments, commissions, and platform revenue</p>
            </div>
            <div className="header-actions">
              <button
                className="btn btn-primary"
                onClick={() => handleBulkAction('export')}
              >
                📊 Export Report
              </button>
            </div>
          </div>
        </div>

        {/* Enhanced Financial Overview */}
        <div className="financial-overview">
          <div className="finance-card total-revenue">
            <div className="finance-content">
              <div className="finance-icon">💰</div>
              <div className="finance-info">
                <h3>Total Revenue</h3>
                <p className="finance-value">
                  KSh {getTotalRevenue().toLocaleString()}
                </p>
                <span className="finance-change positive">+12% this month</span>
              </div>
            </div>
          </div>

          <div className="finance-card commission">
            <div className="finance-content">
              <div className="finance-icon">📊</div>
              <div className="finance-info">
                <h3>Commission Earned</h3>
                <p className="finance-value">
                  KSh {getCommissionEarned().toLocaleString()}
                </p>
                <span className="finance-change positive">+8% this month</span>
              </div>
            </div>
          </div>

          <div className="finance-card pending-payouts">
            <div className="finance-content">
              <div className="finance-icon">🔄</div>
              <div className="finance-info">
                <h3>Pending Payouts</h3>
                <p className="finance-value">
                  KSh {getPendingPayouts().toLocaleString()}
                </p>
                <span className="finance-change neutral">
                  {
                    transactions.filter(
                      (t) => t.status === 'pending' && t.type === 'payout'
                    ).length
                  }{' '}
                  artisans
                </span>
              </div>
            </div>
          </div>

          <div className="finance-card failed">
            <div className="finance-content">
              <div className="finance-icon">❌</div>
              <div className="finance-info">
                <h3>Failed Transactions</h3>
                <p className="finance-value">{getFailedCount()}</p>
                <span className="finance-change negative">
                  -2% failure rate
                </span>
              </div>
            </div>
          </div>
        </div>

        {/* Enhanced Filters */}
        <div className="filters-section">
          <div className="filters-bar">
            <div className="search-box">
              <input
                type="text"
                placeholder="Search by ID, user, or project..."
                value={filters.search}
                onChange={(e) =>
                  setFilters((prev) => ({ ...prev, search: e.target.value }))
                }
              />
              <span className="search-icon">🔍</span>
            </div>

            <div className="filter-group">
              <select
                value={filters.type}
                onChange={(e) =>
                  setFilters((prev) => ({ ...prev, type: e.target.value }))
                }
              >
                <option value="all">All Types</option>
                <option value="payment">Payments</option>
                <option value="payout">Payouts</option>
                <option value="commission">Commissions</option>
                <option value="refund">Refunds</option>
              </select>

              <select
                value={filters.status}
                onChange={(e) =>
                  setFilters((prev) => ({ ...prev, status: e.target.value }))
                }
              >
                <option value="all">All Status</option>
                <option value="completed">Completed</option>
                <option value="pending">Pending</option>
                <option value="failed">Failed</option>
                <option value="cancelled">Cancelled</option>
              </select>

              <select
                value={filters.dateRange}
                onChange={(e) =>
                  setFilters((prev) => ({ ...prev, dateRange: e.target.value }))
                }
              >
                <option value="all">All Time</option>
                <option value="today">Today</option>
                <option value="week">This Week</option>
                <option value="month">This Month</option>
              </select>
            </div>

            <div className="filter-actions">
              <button
                className="btn btn-secondary"
                onClick={() =>
                  setFilters({
                    type: 'all',
                    status: 'all',
                    dateRange: 'all',
                    search: '',
                  })
                }
              >
                Clear Filters
              </button>
              <span className="results-count">
                {filteredTransactions.length} of {transactions.length}{' '}
                transactions
              </span>
            </div>
          </div>
        </div>

        {/* Transactions Section */}
        <div className="transactions-section">
          <div className="section-header">
            <h3>Transaction History</h3>
            <div className="section-actions">
              <select
                className="bulk-actions"
                onChange={(e) => handleBulkAction(e.target.value)}
                defaultValue=""
              >
                <option value="" disabled>
                  Bulk Actions
                </option>
                <option value="export">Export Selected</option>
                <option value="process">Process Pending</option>
                <option value="retry">Retry Failed</option>
              </select>
            </div>
          </div>

          <div className="table-container">
            <table className="transactions-table">
              <thead>
                <tr>
                  <th>
                    <input type="checkbox" className="select-all" />
                  </th>
                  <th>Transaction</th>
                  <th>Type</th>
                  <th>User & Project</th>
                  <th>Amount</th>
                  <th>Status</th>
                  <th>Date & Method</th>
                  <th>Actions</th>
                </tr>
              </thead>
              <tbody>
                {filteredTransactions.map((transaction) => {
                  const statusInfo = getStatusInfo(transaction.status);
                  const typeInfo = getTypeInfo(transaction.type);

                  return (
                    <tr key={transaction.id} className={transaction.status}>
                      <td>
                        <input type="checkbox" className="transaction-select" />
                      </td>
                      <td>
                        <div className="transaction-info">
                          <div className="transaction-id">{transaction.id}</div>
                          <div className="transaction-description">
                            {transaction.description}
                          </div>
                          {transaction.reference && (
                            <div className="transaction-reference">
                              Ref: {transaction.reference}
                            </div>
                          )}
                        </div>
                      </td>
                      <td>
                        <span className={`type-badge ${transaction.type}`}>
                          <span className="type-icon">{typeInfo.icon}</span>
                          {typeInfo.label}
                        </span>
                      </td>
                      <td>
                        <div className="user-project-info">
                          <div className="user-info">
                            <div className="user-avatar">
                              {transaction.user_name?.charAt(0) || 'U'}
                            </div>
                            <div className="user-details">
                              <strong>{transaction.user_name}</strong>
                              <span>{transaction.user_email}</span>
                              <span className="user-type">
                                {transaction.user_type}
                              </span>
                            </div>
                          </div>
                          <div className="project-info">
                            <span className="project-title">
                              {transaction.project_title}
                            </span>
                          </div>
                        </div>
                      </td>
                      <td>
                        <div className="amount-details">
                          <div className="amount-main">
                            KSh {transaction.amount?.toLocaleString()}
                          </div>
                          {transaction.fee > 0 && (
                            <div className="amount-fee">
                              Fee: KSh {transaction.fee?.toLocaleString()}
                            </div>
                          )}
                          <div className="amount-net">
                            Net: KSh {transaction.net_amount?.toLocaleString()}
                          </div>
                        </div>
                      </td>
                      <td>
                        <span
                          className={`status-badge ${transaction.status}`}
                          style={{ backgroundColor: statusInfo.color }}
                        >
                          <span className="status-icon">{statusInfo.icon}</span>
                          {statusInfo.label}
                        </span>
                        {transaction.failure_reason && (
                          <div className="failure-reason">
                            {transaction.failure_reason}
                          </div>
                        )}
                      </td>
                      <td>
                        <div className="date-method-info">
                          <div className="transaction-date">
                            {new Date(
                              transaction.created_at
                            ).toLocaleDateString()}
                          </div>
                          <div className="transaction-time">
                            {new Date(
                              transaction.created_at
                            ).toLocaleTimeString()}
                          </div>
                          <div className="payment-method">
                            {transaction.payment_method}
                          </div>
                          {transaction.completed_at && (
                            <div className="completed-date">
                              Completed:{' '}
                              {new Date(
                                transaction.completed_at
                              ).toLocaleDateString()}
                            </div>
                          )}
                        </div>
                      </td>
                      <td>
                        <div className="action-buttons">
                          <button
                            className="btn btn-sm btn-outline"
                            title="View Details"
                          >
                            👁️ Details
                          </button>
                          <div className="dropdown-actions">
                            {transaction.status === 'pending' && (
                              <button
                                className="btn btn-sm btn-success"
                                onClick={() =>
                                  handleStatusUpdate(
                                    transaction.id,
                                    'completed'
                                  )
                                }
                                title="Approve"
                              >
                                ✅
                              </button>
                            )}
                            {transaction.status === 'failed' && (
                              <button
                                className="btn btn-sm btn-warning"
                                onClick={() =>
                                  handleStatusUpdate(transaction.id, 'pending')
                                }
                                title="Retry"
                              >
                                🔄
                              </button>
                            )}
                            <select
                              value={transaction.status}
                              onChange={(e) =>
                                handleStatusUpdate(
                                  transaction.id,
                                  e.target.value
                                )
                              }
                              className="status-select"
                            >
                              <option value="pending">Pending</option>
                              <option value="completed">Completed</option>
                              <option value="failed">Failed</option>
                              <option value="cancelled">Cancelled</option>
                            </select>
                          </div>
                        </div>
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>

            {filteredTransactions.length === 0 && (
              <div className="empty-state">
                <div className="empty-icon">💰</div>
                <h3>No transactions found</h3>
                <p>
                  No transactions match your current filter criteria. Try
                  adjusting your search or filters.
                </p>
                <button
                  className="btn btn-primary"
                  onClick={() =>
                    setFilters({
                      type: 'all',
                      status: 'all',
                      dateRange: 'all',
                      search: '',
                    })
                  }
                >
                  Clear All Filters
                </button>
              </div>
            )}
          </div>
        </div>

        {/* Section Footer */}
        <div className="section-footer">
          <div className="footer-info">
            Showing {filteredTransactions.length} of {transactions.length}{' '}
            transactions
          </div>
          <div className="pagination">
            <button className="page-btn" disabled>
              ← Previous
            </button>
            <span className="page-info">Page 1 of 1</span>
            <button className="page-btn" disabled>
              Next →
            </button>
          </div>
        </div>
      </div>
    </>
  );
};

export default withAuth(TransactionsManagement, 'admin');
